import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { Link, Redirect } from 'react-router-dom';
// Components
import Card from '../../Components/Card/bigCard';
import ReactTooltip from 'react-tooltip'
import { connect } from 'react-redux';
import axios from 'axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import Cookies from 'universal-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const cookies = new Cookies();

const getState = (state) => {
    return {
        currentEvent: state.currentEvent,
        url: state.url,
    }
}

const Dispatch = (dispatch) => {
    return {
        reservateSeat: (data) => {
            const action = {
                type: 'reservateSeat',
                data: data,
                redirect: false,
            }
            dispatch(action)
        }
    }
}

class EventDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            seats: [],
            width: 1000,
            height: 800,
            open: false,
            seatSelected: '',
            subSeats: [],
            openConfirmReserve: false,
            openWarningMessage: false,
            emptyCart: true,
            cartLength: 0,
        }
    }
    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    getSeats = (url) => {
        axios.get(url + "/api/v1/events/" + this.props.currentEvent.id + "/seat/info/list/")
            .then(response => {
                let data = response.data
                for (let i = 0; i < data.length; i++) {
                    data[i].points = data[i].points.split(' ').join(',');
                }
                this.setState({ seats: data })
            })
            .catch(err => {
                console.log(err)
            })

        if (this.state.seatSelected !== '') {
            axios.get(url + "/api/v1/reservations/availability/sub/" + this.state.seats[this.state.seatSelected].id + "/")
                .then(response => {
                    this.setState({ subSeats: response.data })
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
    componentWillMount = () => {
        let url = this.props.url
        this.getSeats(url)
        axios.get(url + "/api/v1/cart/get/" + cookies.get('key') + "/?data=" + this.props.currentEvent.id)
            .then(response => {
                if (response.data.length > 0) {
                    this.setState({ emptyCart: false, cartLength: response.data.length })
                }
            })
            .catch(err => {
                console.log(err)
            })
    }

    resizeMap = () => {
        let img = document.getElementById('mapEvent')
        let seats = this.state.seats
        if (img !== null) {
            let wPercent = (img.offsetWidth * 100) / this.state.width,
                hPercent = (img.offsetHeight * 100) / this.state.height;
            wPercent = wPercent.toFixed(0);
            hPercent = hPercent.toFixed(0);

            let mapAreas = document.querySelectorAll('#map area')
            let indicator = document.querySelectorAll('.indicator')
            for (let x = 0; x < mapAreas.length; x++) {
                let area = mapAreas[x]
                let ind = indicator[x]
                let index = area.getAttribute('data-index')
                if (typeof seats[index] !== "undefined") {
                    var coords = seats[index]['points'].split(',')
                    let x1 = 9999, x2 = 0, y1 = 9999, y2 = 0;
                    for (var i = 0; i < coords.length; i++) {

                        if (i % 2 === 0) {
                            coords[i] = parseInt((parseInt(coords[i]) * parseInt(wPercent)) / 100);
                        }
                        else {
                            coords[i] = parseInt((parseInt(coords[i]) * parseInt(hPercent)) / 100);
                        }
                        if (i % 2 == 0) {
                            x1 = Math.min(x1, coords[i]);
                            x2 = Math.max(x2, coords[i]);
                        } else {
                            y1 = Math.min(y1, coords[i]);
                            y2 = Math.max(y2, coords[i]);
                        }

                    }
                    let left = ((x2 - x1) / 2) + x1
                    let top = ((y2 - y1) / 2) + y1
                    area.setAttribute('coords', coords.toString());
                    ind.style.left = parseInt(left - 4) + 'px';
                    ind.style.top = parseInt(top - 4) + 'px';
                    ind.style.opacity = 1;
                }
            }
        }
    }

    componentDidMount = () => {
        if (typeof this.props.currentEvent.map_image !== 'undefined') {
            window.addEventListener("resize", this.resizeMap);
            setTimeout(() => {
                this.resizeMap()
            }, 800);
            let url = this.props.url
            this.interval = setInterval(() => this.getSeats(url), 1000);
        }
        if (document.getElementById('description-content') !== null) {
            document.getElementById('description-content').innerHTML = this.props.currentEvent.description;

        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    reserve = (e) => {
        let index = e.target.getAttribute('data-index')
        let url = this.props.url
        if (this.state.seats[index].capacity > 1 && this.state.seats[index].seatype === "Silla / Mesa" && this.state.seats[index].seats[0].status === 'Disponible') {
            axios.get(url + "/api/v1/reservations/availability/sub/" + this.state.seats[index].id + "/")
                .then(response => {
                    this.setState({ open: true, seatSelected: index, subSeats: response.data })
                })
                .catch(err => {
                    console.log(err)
                })
        } else {
            if (this.state.seats[index].seats[0].status === 'Disponible')
                this.setState({ openConfirmReserve: true, seatSelected: index })
            // else
            //     this.setState({ openWarningMessage: true, seatSelected: index })

        }
    }

    ReservateSeat = () => {
        // this.setState({ redirect: true })
        let index = this.state.seatSelected;
        let id = this.state.seats[index].id
        console.log('index', this.state.seats[index])
        let url = this.props.url
        let currentEvent = this.props.currentEvent
        let user = cookies.get('key')
        axios.get(url + "/api/v1/cart/get/" + cookies.get('key') + "/?data=" + this.props.currentEvent.id)
            .then(response => {
                console.log(response.data.length)
                if (response.data.length > 0) {
                    this.setState({ emptyCart: false, cartLength: response.data.length })
                }
                axios.get(url + '/api/v1/reservations/get/availability/' + id + '/')
                    .then(response1 => {
                        console.log(response1.data)
                        if (response1.data[0].status === 'Disponible') {

                            axios.get(url + '/api/v1/reservations/reservated/?event=' + currentEvent.id + '&user=' + user)
                                .then(response2 => {
                                    let reservated = response2.data.length
                                    if (parseInt(response.data.length) < (parseInt(this.props.currentEvent.max_seats) - reservated)) {
                                        this.props.reservateSeat(JSON.stringify(this.state.seats[index]));
                                        this.notify('success');
                                    } else {
                                        this.notify('error');
                                    }
                                    this.setState({ openConfirmReserve: false, emptyCart: false })
                                })
                                .catch(err => {
                                    console.log(err)
                                })
                        } else {
                            this.notify('notAvailable');
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })

            })
            .catch(err => {
                console.log(err)
            })

    }

    hideSweetAlert = () => {
        this.setState({ openConfirmReserve: false })
    }
    hideWarningMessage = () => {
        this.setState({ openWarningMessage: false })
    }
    showWarningMessage = () => {
        this.setState({ openWarningMessage: true })
    }

    reservateSub = (e) => {
        let url = this.props.url
        let id = e.target.getAttribute('id')
        let index = e.target.getAttribute('data-index')
        let name = e.target.getAttribute('data-name')
        let parent = e.target.getAttribute('data-parent')
        let currentEvent = this.props.currentEvent
        let user = cookies.get('key')
        axios.get(url + "/api/v1/cart/get/" + cookies.get('key') + "/?data=" + this.props.currentEvent.id)
            .then(response => {
                axios.get(url + '/api/v1/reservations/reservated/?event=' + currentEvent.id + '&user=' + user)
                    .then(response2 => {
                        let reservated = response2.data.length
                        if (parseInt(response.data.length) < (parseInt(this.props.currentEvent.max_seats) - reservated)) {
                            let subSeats = this.state.subSeats
                            let data = {
                                id: id,
                                parent: parent,
                                name: name,
                                status: 'Pendiente'
                            }
                            axios.get(url + '/api/v1/reservations/get/sub/' + id + '/').
                                then(response1 => {
                                    console.log(response1.data)
                                    if (response1.data.status === 'Disponible') {
                                        axios.put(url + '/api/v1/reservations/availability/sub/pending/' + id + '/', data)
                                            .then(response => {
                                                subSeats[index] = response.data
                                                this.setState({ subSeats })
                                                console.log(response.data)
                                                let data_add_cart = {
                                                    id_availability: response.data.id,
                                                    parent: response.data.parent,
                                                    user: cookies.get('key'),
                                                    type_seat: 'sub',
                                                }
                                                axios.put(url + '/api/v1/reservations/availability/verify/' + data.parent + '/', data_add_cart)
                                                    .then(response => {
                                                        console.log(response.data)
                                                        this.notify('success');
                                                        axios.get(url + "/api/v1/cart/get/" + cookies.get('key') + "/?data=" + this.props.currentEvent.id)
                                                            .then(response => {
                                                                if (response.data.length > 0) {
                                                                    this.setState({ emptyCart: false })
                                                                }
                                                            })
                                                            .catch(err => {
                                                                console.log(err)
                                                            })
                                                    })
                                                    .catch(err => {
                                                        console.log(err)
                                                    })
                                            })
                                            .catch(err => {
                                                console.log(err)
                                            })
                                    } else {
                                        console.log('entro en el error')
                                        this.notify('notAvailable');
                                    }
                                })
                        } else {
                            this.notify('error');
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            })
    }

    notify = (option) => {
        switch (option) {
            case 'success':
                toast.success("¡Asiento Reservado Exitosamente!", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                break;
            case 'error':
                toast.warn("Excedio el límite de asientos para este evento.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                break;
            case 'notAvailable':
                toast.warn("Asiento no disponible.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                break;
            default:
                break;
        }

    }
    render() {
        if (this.state.redirect) {
            return <Redirect to='/checkout' />
        }
        if (typeof this.props.currentEvent.map_image === 'undefined') {
            return <Redirect to={'/'} />
        }
        return (
            <div className="container pt-6">
                <Card>
                    <div className="d-inline back">
                        <Link to='/' className="back-btn"><i className="fa fa-caret-left"></i> Atrás</Link>
                        {this.state.emptyCart
                            ?
                            <a className="paid-btn disabled"><i className="fa fa-cart"></i> Ir a Pagar</a>
                            :
                            <Link to='/checkout' className="paid-btn"><i className="fa fa-cart"></i> Ir a Pagar</Link>
                        }
                    </div>
                    <div className="row pt-6">
                        <div className="offset-sm-1 col-sm-10 text-center">
                            <h2>{this.props.currentEvent.name}</h2>
                            <p className="paragraph text-justify" id='description-content'>{/*Descripcion del evento*/}</p>
                            <h5 className="title-green strong pt-4">Seleccione sus asientos</h5>
                            <div className="map-container pt-6" style={{ position: 'relative' }}>
                                <img draggable="false" src={this.props.url + this.props.currentEvent.map_image} id='mapEvent' useMap="#eventMap" className="map-img" alt="Map Test" />
                                <canvas id="myCanvas"></canvas>
                                <map id='map' name="eventMap">
                                    {
                                        this.state.seats.map((el, key) =>
                                            <area data-tip
                                                data-for={'info' + key}
                                                key={key}
                                                data-index={key}
                                                data-id={el.id}
                                                shape={el.areaType}
                                                coords={el.points}
                                                onClick={this.reserve}
                                                alt={"seat" + el.id} />
                                        )
                                    }
                                    {
                                        this.state.seats.map((el, key) =>
                                            <ReactTooltip id={'info' + key} className='customeTheme' key={key} aria-haspopup='true' role='example' place="right" type="info" >
                                                <ul style={{ listStyleType: 'none', textAlign: 'left', fontSize: '15px' }}>
                                                    <li><strong>{el.name} - {el.ticket.name}</strong></li>
                                                    <li>Capacidad:{el.capacity}</li>
                                                    <li>
                                                        {el.seats[0].status === 'Disponible' ?
                                                            <strong className=''>{el.seats[0].status}</strong>
                                                            :
                                                            null
                                                        }
                                                        {el.seats[0].status === 'Reservado' ?
                                                            <strong className=''>Agotado</strong>
                                                            :
                                                            null
                                                        }
                                                        {el.seats[0].status === 'Pendiente' ?
                                                            <strong className=''>{el.seats[0].status}</strong>
                                                            :
                                                            null
                                                        }
                                                    </li>
                                                </ul>

                                            </ReactTooltip>
                                        )
                                    }
                                </map>
                                {

                                    this.state.seats.map((el, key) => {
                                        let points = el.points.split(',');
                                        let left = points[0]
                                        let top = points[1]
                                        switch (el.seats[0].status) {
                                            case 'Disponible':
                                                return <span key={key} style={{
                                                    position: "absolute",
                                                    float: "left",
                                                    left: left + "px",
                                                    top: top + "px",
                                                    pointerEvents: "none",
                                                    opacity: 0,
                                                    transition: 'all .3s ease',
                                                }}
                                                    className='seat-disponible indicator'></span>
                                            case 'Reservado':
                                                return <span key={key} style={{
                                                    position: "absolute",
                                                    float: "left",
                                                    left: left + "px",
                                                    top: top + "px",
                                                    opacity: 0,
                                                    transition: 'all .3s ease',
                                                    pointerEvents: "none",
                                                }}
                                                    className='seat-reservado indicator'></span>
                                            case 'Pendiente':
                                                return <span key={key} style={{
                                                    position: "absolute",
                                                    float: "left",
                                                    left: left + "px",
                                                    opacity: 0,
                                                    transition: 'all .3s ease',
                                                    top: top + "px",
                                                    pointerEvents: "none",
                                                }} className='seat-pendiente indicator'></span>
                                            default:
                                                break;

                                        }
                                    }
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <div className="d-inline-block legend">
                        <div className="square-orange d-inline-block"></div> Reservado<br />
                        <div className="square-red d-inline-block"></div> No Disponible<br />
                        <div className="square-green d-inline-block"></div> Disponible<br />
                    </div>
                </Card>
                <Modal open={this.state.open} onClose={this.onCloseModal} classNames={{ overlay: 'custom-overlay', modal: 'custom-modal' }} center closeIconSize={20}>
                    <h5>Seleccione los puestos que desea reservar</h5>
                    <div className='content-seats'>
                        {
                            this.state.subSeats.map((el, key) => {
                                switch (el.status) {
                                    case 'Disponible':
                                        return <div key={key}
                                            id={el.id}
                                            data-name={el.name}
                                            data-parent={el.parent}
                                            data-index={key}
                                            onClick={this.reservateSub}
                                            className="seat"
                                            style={{ backgroundColor: 'rgb(0, 255, 162)', width: ((300 / (this.state.subSeats.length / 2)) - 5) + 'px' }}
                                        ></div>
                                    case 'Reservado':
                                        return <div key={key}
                                            id={el.id}
                                            data-name={el.name}
                                            data-parent={el.parent}
                                            data-index={key}
                                            // onClick={this.showWarningMessage}
                                            className="seat"
                                            style={{ backgroundColor: 'rgb(231, 4, 31)', width: ((300 / (this.state.subSeats.length / 2)) - 5) + 'px' }}
                                        ></div>
                                    case 'Pendiente':
                                        return <div key={key}
                                            id={el.id}
                                            data-name={el.name}
                                            data-parent={el.parent}
                                            data-index={key}
                                            // onClick={this.showWarningMessage}
                                            className="seat"
                                            style={{ backgroundColor: 'rgb(255, 123, 0)', width: ((300 / (this.state.subSeats.length / 2)) - 5) + 'px' }}
                                        ></div>
                                    default:
                                        break;

                                }
                            })
                        }
                    </div>
                    <div className='content-btns'>
                        <button className="btn btn-lg btn-default" onClick={this.onCloseModal}>Volver</button>
                        {this.state.emptyCart
                            ?
                            <a className="btn btn-lg disabled"><i className="fa fa-cart"></i>Comprar Asientos</a>
                            :
                            <Link to='/checkout' className="btn btn-lg btn-success">Comprar Asientos</Link>
                        }

                    </div>
                </Modal>
                <SweetAlert
                    warning
                    show={this.state.openConfirmReserve}
                    showCancel
                    confirmBtnText="Reservar"
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="default"
                    cancelBtnText="Cancelar"
                    title="¿Desea continuar?"
                    onConfirm={this.ReservateSeat}
                    onCancel={this.hideSweetAlert}
                >
                    Presione el botón reservar para proceder con la reserevación.
                </SweetAlert>
                <SweetAlert
                    danger
                    show={this.state.openWarningMessage}
                    confirmBtnText="Continuar"
                    confirmBtnBsStyle="default"
                    title="Asiento no disponible"
                    onConfirm={this.hideWarningMessage}
                >
                    No se puede reservar este asiento.
                </SweetAlert>
                <ToastContainer position="bottom-right"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover />
            </div>
        );
    }
}

export default connect(getState, Dispatch)(EventDetails);


// WEBPACK FOOTER //
// ./src/Pages/EventDetails/index.js